import { render } from "./FrmExpedition.vue?vue&type=template&id=7c5febe0"
import script from "./FrmExpedition.vue?vue&type=script&lang=js"
export * from "./FrmExpedition.vue?vue&type=script&lang=js"

import "./FrmExpedition.vue?vue&type=style&index=0&id=7c5febe0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__